'use strict';

var pill = require('../../../../../../../../../../_virtual/pill.cjs');
var intentionColors = require('../../base/ds5/intentionColors.cjs');

var hasRequiredPill;

function requirePill () {
	if (hasRequiredPill) return pill.__exports;
	hasRequiredPill = 1;

	var intentionColors$1 = intentionColors.__require();

	var PILL_INTENTIONS = /*#__PURE__*/ function(PILL_INTENTIONS) {
	    PILL_INTENTIONS[PILL_INTENTIONS["neutral"] = intentionColors$1.INTENTION_COLORS.neutral] = "neutral";
	    PILL_INTENTIONS[PILL_INTENTIONS["success"] = intentionColors$1.INTENTION_COLORS.success] = "success";
	    PILL_INTENTIONS[PILL_INTENTIONS["critical"] = intentionColors$1.INTENTION_COLORS.critical] = "critical";
	    PILL_INTENTIONS[PILL_INTENTIONS["warning"] = intentionColors$1.INTENTION_COLORS.warning] = "warning";
	    PILL_INTENTIONS[PILL_INTENTIONS["discovery"] = intentionColors$1.INTENTION_COLORS.discovery] = "discovery";
	    PILL_INTENTIONS[PILL_INTENTIONS["recur"] = intentionColors$1.INTENTION_COLORS.recur] = "recur";
	    PILL_INTENTIONS[PILL_INTENTIONS["info"] = intentionColors$1.INTENTION_COLORS.info] = "info";
	    return PILL_INTENTIONS;
	}({});

	pill.__exports.PILL_INTENTIONS = PILL_INTENTIONS;
	
	return pill.__exports;
}

exports.__require = requirePill;
//# sourceMappingURL=pill.cjs.map
